/**
 * SG AGM Exempted AFS — 엔티티 감사인 자동 채움·표시명.
 */
import type { AgmExemptedAfsFormModel } from './useFormPayload';

function trim(v: unknown): string {
  return v === null || v === undefined ? '' : String(v).trim();
}

export function pickAuditorDisplayName(raw: unknown): string {
  const r = (raw && typeof raw === 'object' ? raw : {}) as Record<string, unknown>;
  return trim(
    r.name
    ?? r.contactName
    ?? r.firmName
    ?? r.companyName
    ?? r.CONTACT_NAME
    ?? `${r.firstName || ''} ${r.surname || r.lastName || ''}`.trim(),
  );
}

/** API auditors[] → 표시용 이름 목록 (중복 제거) */
export function mapAuditorsFromApi(list: unknown[]): string[] {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const item of list) {
    if (!item || typeof item !== 'object') continue;
    const name = pickAuditorDisplayName(item as Record<string, unknown>);
    if (!name) continue;
    const key = name.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(name);
  }
  return out;
}

/** 비어 있을 때 첫 번째 감사인 1명 자동 지정 */
export function applyDefaultAuditorToForm(
  model: AgmExemptedAfsFormModel,
  auditorNames: string[],
): void {
  if (trim(model.auditorName)) return;
  const first = auditorNames.find((n) => trim(n));
  if (first) model.auditorName = first;
}
